import { cn } from '../../lib/css/className/className';
import { BaseStackProps } from '../../components/Stack/types';
import { getScrollbarClassName } from '../../lib/css/getScrollbarClassName';
import './useStack.css';

const cls = cn('Stack');

type StackForbiddenProps = 'as' | 'className' | 'children';

export type StackHookOptions = Omit<BaseStackProps, StackForbiddenProps>;
export type HVStackHookOptions = Omit<BaseStackProps, StackForbiddenProps | 'type' | 'scrollAxis'> & {
    scrollable?: boolean;
};

/**
 * React Hook для выравнивания дочерних элементов с помощью flex-свойств.
 */
export const useStack = (options: StackHookOptions): string => {
    const {
        type = 'horizontal',
        scrollAxis,

        flexWrap,
        justifyContent,
        alignItems,

        gap,

        inline,
    } = options;
    const scrollClass = getScrollbarClassName();

    return cls({ type, scrollAxis, gap, flexWrap, justifyContent, alignItems, inline }, [
        scrollAxis && scrollAxis !== 'none' ? scrollClass : undefined,
    ]);
};

/**
 * React Hook для горизонтального выравнивания дочерних элементов с помощью flex-свойств.
 */
export const useHStack = (options: HVStackHookOptions): string => {
    const { scrollable, ...otherProps } = options;

    const scrollAxis = scrollable ? 'x' : undefined;
    return useStack({
        scrollAxis,
        ...otherProps,
    });
};

/**
 * React Hook для вертикального выравнивания дочерних элементов с помощью flex-свойств.
 */
export const useVStack = (options: HVStackHookOptions): string => {
    const { scrollable, ...otherProps } = options;

    const scrollAxis = scrollable ? 'y' : undefined;
    return useStack({
        type: 'vertical',
        scrollAxis,
        ...otherProps,
    });
};
